import { MIX_PANEL_PAGE_NAME } from './constants';

export const getMixPanelCommonProperties = ({
    layoutId,
    buyerState,
    componentName,
}: {
    layoutId: string;
    buyerState: string;
    componentName?: string;
}) => ({
    'Page Name': MIX_PANEL_PAGE_NAME,
    'Layout Id': layoutId,
    'Buyer State': buyerState,
    ...(componentName ? { 'Component Name': componentName } : {}),
});
